import ViewClientExternalEffects from "@views/ViewAdminPanel/views/ViewClientExternalEffects";
import ViewClientModel from "@views/ViewAdminPanel/views/ViewClientModel";
import ViewClientModels from "@views/ViewAdminPanel/views/ViewClientModels";
import ViewHome from "@views/ViewAdminPanel/views/ViewHome";
import ViewNewClient from "@views/ViewAdminPanel/views/ViewNewClient";
import ViewNewClientModel from "@views/ViewAdminPanel/views/ViewNewClientModel";
import ViewNewUser from "@views/ViewAdminPanel/views/ViewNewUser";
import ViewUpdateClient from "@views/ViewAdminPanel/views/ViewUpdateClient";
import ViewUpdateUser from "@views/ViewAdminPanel/views/ViewUpdateUser";
import ViewUsers from "@views/ViewAdminPanel/views/ViewUsers";

export const ROUTING_ADMIN_HOME = "";
export const ROUTING_ADMIN_NEW_CLIENT = "/clients/new";
export const ROUTING_ADMIN_NEW_CLIENT_MODEL = "/clients/:id/models/new";
export const ROUTING_ADMIN_EDIT_CLIENT = "/clients/:id";
export const ROUTING_ADMIN_CLIENT_EXTERNAL_EFFECTS =
  "/clients/external-effects";
export const ROUTING_ADMIN_CLIENT_MODELS = "/clients/models";
export const ROUTING_ADMIN_CLIENT_MODEL = "/clients/:id/models/:modelId";
export const ROUTING_ADMIN_USERS = "/users";
export const ROUTING_ADMIN_NEW_USER = "/users/new";
export const ROUTING_ADMIN_EDIT_USER = "/users/:id";

const ROUTES = {
  HOME: ROUTING_ADMIN_HOME,
  NEW_CLIENT: ROUTING_ADMIN_NEW_CLIENT,
  EDIT_CLIENT: ROUTING_ADMIN_EDIT_CLIENT,
  EXTERNAL_EFFECTS: ROUTING_ADMIN_CLIENT_EXTERNAL_EFFECTS,
  MODELS: ROUTING_ADMIN_CLIENT_MODELS,
  NEW_CLIENT_MODEL: ROUTING_ADMIN_NEW_CLIENT_MODEL,
  CLIENT_MODEL: ROUTING_ADMIN_CLIENT_MODEL,
  USERS: ROUTING_ADMIN_USERS,
  NEW_USER: ROUTING_ADMIN_NEW_USER,
  EDIT_USER: ROUTING_ADMIN_EDIT_USER
};

export type AdminPanelRouteConfig = {
  path: string;
  component: () => JSX.Element;
};

export const AdminModulesConfig: { [key: string]: AdminPanelRouteConfig } = {
  [ROUTING_ADMIN_HOME]: {
    path: ROUTES.HOME,
    component: ViewHome
  },
  [ROUTING_ADMIN_NEW_CLIENT]: {
    path: ROUTING_ADMIN_NEW_CLIENT,
    component: ViewNewClient
  },
  [ROUTING_ADMIN_EDIT_CLIENT]: {
    path: ROUTING_ADMIN_EDIT_CLIENT,
    component: ViewUpdateClient
  },
  [ROUTING_ADMIN_CLIENT_EXTERNAL_EFFECTS]: {
    path: ROUTING_ADMIN_CLIENT_EXTERNAL_EFFECTS,
    component: ViewClientExternalEffects
  },
  [ROUTING_ADMIN_CLIENT_MODELS]: {
    path: ROUTING_ADMIN_CLIENT_MODELS,
    component: ViewClientModels
  },
  [ROUTING_ADMIN_NEW_CLIENT_MODEL]: {
    path: ROUTING_ADMIN_NEW_CLIENT_MODEL,
    component: ViewNewClientModel
  },
  [ROUTING_ADMIN_CLIENT_MODEL]: {
    path: ROUTING_ADMIN_CLIENT_MODEL,
    component: ViewClientModel
  },
  [ROUTING_ADMIN_USERS]: {
    path: ROUTING_ADMIN_USERS,
    component: ViewUsers
  },
  [ROUTING_ADMIN_NEW_USER]: {
    path: ROUTING_ADMIN_NEW_USER,
    component: ViewNewUser
  },
  [ROUTING_ADMIN_EDIT_USER]: {
    path: ROUTING_ADMIN_EDIT_USER,
    component: ViewUpdateUser
  }
};
